export default "__VITE_ASSET__DFJxhsjn__"